import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { Fragment } from "react";
import { Can } from "@/components/citadel/can";
import { AddArticleModal } from "@/modals/stock/add-article-modal";
import { AddOrderTemplateModal } from "@/modals/stock/add-order-template-modal";

export function ArticlesMenu() {
	/** Context */
	const { refetch, hasRowSelection, getSelectedRowIds, table } = useDataTableContext();

	/** Hooks */
	const { t } = useTranslation();
	const addArticleModal = useDisclosure();
	const addOrderTemplateModal = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<Can
				action="create"
				subject="Stock"
			>
				<Button
					variant="primary"
					icon={<Icon name="Sparkle" />}
					isDisabled={!hasRowSelection}
					onClick={addOrderTemplateModal.onOpen}
				>
					{t("stock.create_order_template")}
				</Button>
				<Button
					onClick={addArticleModal.onOpen}
					variant="primary"
					icon={<Icon name="Plus" />}
					data-cy="add-articles-button"
				>
					{t("stock.add_article")}
				</Button>
			</Can>
			{addArticleModal.isOpen && (
				<AddArticleModal
					isOpen={addArticleModal.isOpen}
					onClose={addArticleModal.onClose}
					onComplete={refetch}
				/>
			)}
			{addOrderTemplateModal.isOpen && (
				<AddOrderTemplateModal
					isOpen={addOrderTemplateModal.isOpen}
					onClose={() => {
						table.resetRowSelection();
						addOrderTemplateModal.onClose();
					}}
					initialSelection={getSelectedRowIds()}
				/>
			)}
		</Fragment>
	);
}
